<app-truck-sidebar></app-truck-sidebar>
<form [formGroup]="paymentForm">
  <div class="truck-owner-details">
    <div class="row payment-top">
      <div class="col-sm-3">
        <mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="picker1">
          </mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <input
            matInput
            [(ngModel)]="from_Date"
            formControlName="from_date"
            [matDatepicker]="picker1"
            placeholder="From Date"
            (click)="picker1.open()"
          />
        </mat-form-field>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="picker2">
          </mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <input
            [(ngModel)]="to_Date"
            matInput
            formControlName="to_date"
            [matDatepicker]="picker2"
            placeholder="To Date"
            (click)="picker2.open()"
          />
        </mat-form-field>
      </div>

      <div class="col-md-4 truck-owner-header-search mtb">
        <input
          [(ngModel)]="search_Number"
          type="text"
          appAlphanumericOnly
          toUppercase
          matInput
          placeholder="Search by truck number"
          formControlName="truck_number"
          maxlength="10"
          minlength="10"
          matTooltip="Please enter valid Truck Number"
        />
      </div>
      <div class="col-sm-1" *ngIf="search_btn">
        <button type="button" class="buttonBlue">
          <img
            type="button"
            class="search_number"
            (click)="dataSearch()"
            src="../../../assets/img/search-white.svg"
          />
        </button>
      </div>
      <div class="col-sm-1" *ngIf="clear_btn">
        <button
          type="button"
          class="buttonBlue"
          (click)="resetTruckTrackInfo()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            class="search_number"
          >
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="truck-owner-items">
      <div class="row">
        <div class="row ml-0 mr-0">
          <div class="col-md-12">
            <div class="left-side-bar">
              <p>Account Summary</p>
            </div>
            <div class="card-details card-details-total">
              <div class="card-details card-details-total">
                <div class="trip-details-left">Total Receivable</div>
                <div class="trip-details-right">
                  ₹ {{ totalReceivable | number : "1.2-2" }}
                </div>
                <div class="trip-details-left">Total Deduction</div>
                  <div class="trip-details-right">
                    ₹ {{ totalDeduction | number : "1.2-2" }}
                  </div>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div class="trip-details-left">Actual Receivable</div>
            <div class="trip-details-right">
              ₹ {{ actualReceivable | number : "1.2-2" }}
            </div>
            <div class="trip-details-left">S9 Paid</div>
            <div class="trip-details-right">
              ₹ {{ s9Payment | number : "1.2-2" }}
            </div>
            <div class="trip-details-left">Balance Amount</div>
            <div class="trip-details-right">
              ₹ {{ actualReceivable - s9Payment | number : "1.2-2"}}
            </div>
          </div>          
        </div>
        <div class="truck-owner-header-search">
          <input
            [(ngModel)]="search_TripID"
            type="text"
            appAlphanumericOnly
            toUppercase
            formControlName="trip_id"
            placeholder="Search Trip ID"
            #newItem
            maxlength="10"
            minlength="4"
          />
          <a class="truck-header-search-icon">
            <img
              *ngIf="search_BTN"
              (click)="searchTripId(newItem.value)"
              src="assets/img/search.svg"
            />
            <img
              *ngIf="clear_search_BTN"
              (click)="resetTripId()"
              src="../../../assets/img/x-cross.svg"
              alt=""
            />
          </a>
        </div>
      </div>
      <div class="row pay m-0 mt-3 p-2 scroll">
        <div [class.spinner]="loading"></div>

        <div class="row to_container" *ngIf="!paymentArray?.length && !loading">
          <h4 class="error_msg">No Records Found.</h4>
        </div>

        <div *ngFor="let item of paymentArray" class="trip-details-container">
          <form>
            <div class="row ml-0 mr-0 p-2">
              <div class="col-md-3">
                <div class="head">Trip ID:</div>
                <h6 class="dec" style="cursor: pointer;" (click)="viewTripSummary(item)">
                  {{ item.trip_id }}
                </h6>
              </div>
        
              <div class="col-md-3">
                <div class="head">Amount:</div>
                <h6 class="dec">
                  ₹ {{ calculateAmount(item) | number: "1.2-2" }}
                </h6>
              </div>
        
              <div class="col-md-3">
                <div class="head">Deduction:</div>
                <h6 class="dec">
                  ₹ {{ calculateDeductions(item) | number: "1.2-2" }}
                </h6>
              </div>
        
              <div class="col-md-3">
                <div class="head">Date:</div>
                <h6 class="dec">
                  {{
                    (item.truckownerPaymentInfo && item.truckownerPaymentInfo.length > 0)
                    ? (item.truckownerPaymentInfo[item.truckownerPaymentInfo.length - 1]?.payment_date || item.pickup_date | date : "dd-MM-yyyy")
                    : (item.pickup_date | date : "dd-MM-yyyy")
                  }}
                </h6>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</form>
